export default __webpack_public_path__ + "static/media/I0001.a7ce7720.png";